export default "__VITE_ASSET__C9YAga53__"